var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isOpenModal
        ? _c("modal-view", {
            attrs: { isCarousel: false, entity: _vm.selectedVideo },
            on: {
              close: function ($event) {
                _vm.isOpenModal = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "flex justify-between" }, [
        _c("span", { staticClass: "text-2xl font-bold py-2 md:text-4xl" }, [
          _vm._v("Related Videos"),
        ]),
        _vm._v(" "),
        _vm.canScrollLeft || _vm.canScrollRight
          ? _c("div", { staticClass: "flex" }, [
              _c(
                "button",
                {
                  staticClass: "rounded-3xl disabled:cursor-not-allowed",
                  class: {
                    disabled: !_vm.canScrollLeft,
                  },
                  attrs: { disabled: !_vm.canScrollLeft },
                  on: { click: _vm.scrollLeft },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "34",
                        height: "34",
                        viewBox: "0 0 34 34",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        "svg-inline": "",
                        role: "presentation",
                        focusable: "false",
                        tabindex: "-1",
                      },
                    },
                    [
                      _c(
                        "g",
                        { attrs: { "clip-path": "url(#clip0_1778_939)" } },
                        [
                          _c("path", {
                            attrs: {
                              d: "M17.707 11.707l-1.414-1.414L9.586 17l6.707 6.707 1.414-1.414L13.414 18H23v-2h-9.586l4.293-4.293z",
                              fill: "#367C2B",
                            },
                          }),
                          _c("circle", {
                            attrs: {
                              cx: "17",
                              cy: "17",
                              r: "16.5",
                              stroke: "#367C2B",
                            },
                          }),
                        ]
                      ),
                      _c("defs", [
                        _c("clipPath", { attrs: { id: "clip0_1778_939" } }, [
                          _c("path", {
                            attrs: { fill: "#fff", d: "M0 0h34v34H0z" },
                          }),
                        ]),
                      ]),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass:
                    "rounded-3xl rotate-180 ml-2 disabled:cursor-not-allowed",
                  class: {
                    disabled: !_vm.canScrollRight,
                  },
                  attrs: { disabled: !_vm.canScrollRight },
                  on: { click: _vm.scrollRight },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "34",
                        height: "34",
                        viewBox: "0 0 34 34",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        "svg-inline": "",
                        role: "presentation",
                        focusable: "false",
                        tabindex: "-1",
                      },
                    },
                    [
                      _c(
                        "g",
                        { attrs: { "clip-path": "url(#clip0_1778_939)" } },
                        [
                          _c("path", {
                            attrs: {
                              d: "M17.707 11.707l-1.414-1.414L9.586 17l6.707 6.707 1.414-1.414L13.414 18H23v-2h-9.586l4.293-4.293z",
                              fill: "#367C2B",
                            },
                          }),
                          _c("circle", {
                            attrs: {
                              cx: "17",
                              cy: "17",
                              r: "16.5",
                              stroke: "#367C2B",
                            },
                          }),
                        ]
                      ),
                      _c("defs", [
                        _c("clipPath", { attrs: { id: "clip0_1778_939" } }, [
                          _c("path", {
                            attrs: { fill: "#fff", d: "M0 0h34v34H0z" },
                          }),
                        ]),
                      ]),
                    ]
                  ),
                ]
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "scrollContainer",
          staticClass:
            "flex w-full scrollbar-hide overflow-x-auto snap-x snap-mandatory gap-4",
          on: { scroll: _vm.checkScroll },
        },
        _vm._l(_vm.videos, function (video, key) {
          return _c(
            "div",
            { staticClass: "flex-none w-[285px] xs:w-[338px] snap-start" },
            [
              _c(
                "div",
                {
                  staticClass: "video-slide w-full relative block m-0",
                  attrs: { title: video.title },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "cursor-pointer",
                      on: {
                        click: function ($event) {
                          return _vm.openModalWithVideo(video)
                        },
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "playlist-thumb w-full video-thumb mb-2",
                        attrs: {
                          src: video.thumbnail,
                          alt: video.title + " Thumbnail",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "hover:cursor-pointer opacity-0 transform absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 play-icon",
                        },
                        [_c("play-icon")],
                        1
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              video.isVimeo
                ? _c(
                    "label",
                    {
                      staticClass:
                        "rounded-full px-2 py-0.5 bg-we-yellow justify-center items-center text-black text-[10px] font-semibold",
                    },
                    [_vm._v("\n          Product Video\n        ")]
                  )
                : _c(
                    "label",
                    {
                      staticClass:
                        "rounded-full px-2 py-0.5 bg-we-light justify-center items-center text-white text-[10px] font-semibold",
                    },
                    [_vm._v("\n          Tutorial\n        ")]
                  ),
              _vm._v(" "),
              _c(
                "h3",
                {
                  staticClass:
                    "font-bold m-0 text-xs md:text-base heading-five mt-4",
                },
                [
                  _c(
                    "a",
                    {
                      attrs: {
                        target: "_blank",
                        href: video.detail_page_url,
                        title: video.title,
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(video.short_title) +
                          "\n          "
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "timestamp my-2" }, [
                _vm._v(_vm._s(video.human_published_at)),
              ]),
            ]
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./resources/js/Components/new/VideoSliderView.vue